import axios from "axios";

const companyContext = (query = {}) => {
  const parsed = Number(query.companyId || query.company_id);
  return Number.isInteger(parsed) && parsed > 0 ? { company_id: parsed } : {};
};

export const loadAiSettings = (query) => {
  const context = companyContext(query);
  return axios.get("/ai/settings", {
    params: Object.keys(context).length ? context : undefined,
  });
};

export const saveAiProviderSettings = ({ providerKey, draft, query }) =>
  axios.put(`/ai/settings/providers/${providerKey}`, {
    label: draft.label,
    api_key: draft.apiKey,
    status: draft.status,
    ...companyContext(query),
  });

export const testAiProviderSettings = ({ providerKey, query }) =>
  axios.post(`/ai/settings/providers/${providerKey}/test`, companyContext(query));

export const saveAiProfileSettings = ({ profileKey, draft, query }) =>
  axios.put(`/ai/settings/profiles/${profileKey}`, {
    ...draft,
    ...companyContext(query),
  });
